{
  "title": "Fizban's Platinum Shield (UA)",
  "source": "Unearthed Arcana 78 - Draconic Options",
  "levelAndSchool": "6th-level abjuration",
  "level": 6,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S, M (a platinum-plated dragon scale, worth at least 500 gp)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You create a field of silvery light that surrounds a creature of your choice within range (you can choose yourself). The field sheds dim light out to 5 feet.",
    "As a bonus action on subsequent turns, you can move the field to another creature within 60 feet of the field.",
    "The creature protected by the field gains the following benefits:",
    "The creature has half cover.",
    "The creature has resistance to acid, cold, fire, lightning, and poison damage.",
    "If the creature is subjected to an effect that allows it to make a Dexterity saving throw to take only half damage, the creature instead takes no damage if it succeeds on the saving throw, and only half damage if it fails."
  ],
  "spellLists": ["sorcerer", "wizard"]
}
